import { render, staticRenderFns } from "./WellnessOverviewChart.vue?vue&type=template&id=4d9cc3a4&scoped=true"
import script from "./WellnessOverviewChart.vue?vue&type=script&lang=js"
export * from "./WellnessOverviewChart.vue?vue&type=script&lang=js"
import style0 from "./WellnessOverviewChart.vue?vue&type=style&index=0&id=4d9cc3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9cc3a4",
  null
  
)

export default component.exports